import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class SequenceItemModel extends BaseModel {
  uuid = null;
  type = null;
  sorting = null;
  items = []
  dynamic_field_key = null
  dynamic_field = null


  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    type: 'required',
    sorting: 'required',
    dynamic_field_key: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
  }

}
